import ReactGA4 from 'react-ga4';
import { WizardInteractionEventPayload } from '../../types/GA4Events/WizardEventParams';

export const createWizardEventPayload = (
  partial: Partial<WizardInteractionEventPayload>
): WizardInteractionEventPayload => ({
  // non-null assertion suppressed because providing fallback value can result in wrong data in GA explorations
  // eslint-disable-next-line
  wizard_interaction_type: partial.wizard_interaction_type!, // required
  wizard_step: partial.wizard_step ?? 0,
  // non-null assertion suppressed because providing fallback value can result in wrong data in GA explorations
  // eslint-disable-next-line
  wizard_type: partial.wizard_type!,
  wizard_entry_trigger: partial.wizard_entry_trigger,
  wizard_exit_trigger: partial.wizard_exit_trigger,
  wizard_import_decision: partial.wizard_import_decision,
  wizard_units_saved: partial.wizard_units_saved ?? 0,
  wizard_schema_version: partial.wizard_schema_version ?? 'v2',
});

const trackWizardEvent = (payload: WizardInteractionEventPayload) => {
  const eventName = "wizard_interaction";
  console.log(
    "GA4 Event:",
    eventName,
    payload,
    sessionStorage.getItem("propertyCode"), sessionStorage.getItem("isInternalUser") ? "internal" : "external");
  ReactGA4.event(eventName, {
    ...payload,
    transport_type: "beacon",
  });
};

export default trackWizardEvent;